
 
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Backup</div> 
        <div class="row mt-2 ml-3">
           <div class="input-group col-md-8 ">         
            <button (click)="createBackupBtnClick()" class="btn btn-success"><i class="fa fa-database p-1"></i>
            <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
             Create Backup
            </button> 
          </div>   
        </div>

        <!-- <div class="lds-spinner" *ngIf="showrRestoringIndicator"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>    -->

        <form class="form-horizontal">
        <fieldset>
        <div class="card-body">
  
          <div>
            <mat-table [dataSource]="dataSource" matSort>
             
              <ng-container matColumnDef="filename">
                <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Filename </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.Filename}} </mat-cell>
              </ng-container>
                       
              <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Date </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.DateCreated}} </mat-cell>
              </ng-container>
                      
              <ng-container matColumnDef="createdBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Created by </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.CreatedBy}} </mat-cell>
              </ng-container>
                       
              <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef [ngClass]="{'dark-bg' : isDark }"> Action </mat-header-cell>
                <mat-cell *matCellDef="let row" [ngClass]="{'dark-bg' : isDark }">
                  <button class="btn btn-primary btn-sm text-white" (click)="downloadBtnClick(row.Filename)" data-toggle="viewTooltip" data-placement="bottom" title="Download"><i class="fa fa-download"></i></button>
                  <button class="btn btn-danger btn-sm ml-1 text-white"  (click)="deleteButtonClick(row.Filename)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i></button>      
                </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="loading">
                <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> Loading data... </mat-footer-cell> 
              </ng-container>
  
              <ng-container matColumnDef="noData">
                <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> No data available in table </mat-footer-cell> 
              </ng-container>
            
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
              <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
            </mat-table>
  
            <mat-paginator [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  
            </div>
  
  
        </div>                                
        <!-- /.card-body -->
  
      </fieldset>
        </form>
      </div>
  
    
  <script>
  
    $(function () {
    $('[data-toggle="viewTooltip"]').tooltip()
  })
  $(function () {
    $('[data-toggle="deleteTooltip"]').tooltip()
  })
  </script>
  

